module.exports = __webpack_public_path__ + "static/medicare-centrelink-2bf128a67d59d76bd129649e9192a952.png";